<!-- Phone: a search icon that expands the box; desktop: the box is always visible. -->
<button type="button" class="gs-mobile-toggle" (click)="toggleMobile()"
        matTooltip="Search" aria-label="Search">
    <mat-icon>search</mat-icon>
</button>

<div class="gs-wrap" [class.mobile-open]="mobileOpen">
    <mat-icon class="gs-icon">search</mat-icon>
    <input class="gs-input" type="search" [(ngModel)]="term" (input)="onInput()" (focus)="onFocus()"
           placeholder="Search your workspaces..." aria-label="Search your workspaces" />

    <div *ngIf="open" class="gs-panel">
        <div *ngIf="groups.length === 0" class="gs-status">
            No pages match in the workspaces you have access to.
        </div>

        <ng-container *ngFor="let g of groups">
            <div class="gs-group">{{ g.workspace }}</div>
            <button *ngFor="let p of g.pages" type="button" class="gs-result" (click)="pick(p)">
                <span class="material-symbols-outlined gs-result-icon">{{ p.icon }}</span>
                <span class="gs-result-title">{{ p.label }}</span>
            </button>
        </ng-container>
    </div>
</div>
